/**
 * Pure utility functions for generating CMe3100 credentials files.
 * Extracted to allow direct unit testing without kubb/component dependencies.
 */

interface CredentialsGateway {
  asset_id: string;
  company_id: string;
  serial_number?: string;
  manufacturer?: string;
  model?: string;
  credentials: { password?: string } | unknown;
}

export function isCMe3100Gateway(gateway: CredentialsGateway): boolean {
  return gateway.manufacturer === "elvaco" && !!gateway.model?.includes("3100");
}

export function buildCredentialsFileContent(
  gateway: CredentialsGateway,
  hesConfig: { cme: string; cme2100: string },
): string {
  const isCMe2100Model = !!gateway.model && gateway.model.indexOf("21") !== -1;
  const postUrl = isCMe2100Model
    ? `${hesConfig.cme2100}${gateway.company_id}`
    : `${hesConfig.cme}/${gateway.company_id}`;
  const credentials = gateway.credentials as { password?: string };
  const password = credentials?.password ?? "";

  return [
    "Endpoint URL:",
    postUrl,
    "",
    "Auto-Configuration Username:",
    gateway.asset_id,
    "",
    "Auto-Configuration Password:",
    password,
    "",
    "Web Interface Username:",
    "admin",
    "",
    "Web Interface Password:",
    `${password}!`,
  ].join("\n");
}

export function getCredentialsFilename(gateway: CredentialsGateway): string {
  return `credentials_${gateway.serial_number || gateway.asset_id}.txt`;
}
